import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const RecaptchaProvider = ({ children }) => {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  // NODE_ENV is set automatically by CRA ('development' for npm start, 'production'
  // for npm run build) — this keeps reCAPTCHA off in local dev even if a real site
  // key ends up in a local .env, so it never fires against Google in dev.
  const recaptchaEnabled = process.env.NODE_ENV === 'production';

  if (!siteKey || !recaptchaEnabled) {
    return children;
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head',
        nonce: undefined,
      }}
    >
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default RecaptchaProvider;
